/** RingsDB serves some double-faced cards as one PNG (two faces stacked or side-by-side). */
export function classifyTwinImage(naturalW, naturalH) {
  if (!naturalW || !naturalH) return "single";
  const tall = naturalH / naturalW;
  const wide = naturalW / naturalH;
  if (tall >= 1.82) return "verticalTwin";
  if (wide >= 1.82) return "horizontalTwin";
  return "single";
}
